import { useNavigate } from "react-router-dom";
import { Box, Typography, Button } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import { tokens } from "../../theme";

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        background: tokens.bg,
        gap: 1.5,
        px: 2,
      }}
    >
      <Box
        sx={{
          width: 72,
          height: 72,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: tokens.accentSoft,
          mb: 0.5,
        }}
      >
        <SearchOffIcon sx={{ fontSize: 34, color: tokens.accent }} />
      </Box>
      <Typography
        sx={{
          fontSize: 56,
          fontWeight: 800,
          color: tokens.text,
          lineHeight: 1,
          letterSpacing: "-.02em",
        }}
      >
        404
      </Typography>
      <Typography sx={{ fontSize: 18, fontWeight: 700, color: tokens.text }}>
        Page not found
      </Typography>
      <Typography sx={{ fontSize: 13, color: tokens.text3, textAlign: "center", maxWidth: 320 }}>
        The page you&apos;re looking for doesn&apos;t exist or you don&apos;t have access.
      </Typography>
      <Button
        variant="contained"
        disableElevation
        size="small"
        startIcon={<HomeIcon />}
        onClick={() => navigate("/dashboard")}
        sx={{
          mt: 1.5,
          borderRadius: "8px",
          fontWeight: 700,
          fontSize: 13,
          height: 36,
          px: 2,
        }}
      >
        Back to Dashboard
      </Button>
    </Box>
  );
};

export default NotFound;
